import { MatSelectionList } from '@angular/material/list';
import { jkRestReturnClass } from './jkClass';
import { JkEntityV2 } from './jkEntityV2';
import { JkPopup } from './jkPopup';


export class jkListSet<T>{
  list!: MatSelectionList;
  entity?: JkEntityV2;
  popEdit: JkPopup;
  onPopEditOk?: (ret: jkRestReturnClass) => void; // doOk callback
  popEditHide(e: any) {
    this.popEdit.popupVisible = false;
  }
  popFilter: JkPopup; // query form
  onPopFilterOk?: (e: any) => void; // doOk callback
  isInsert: boolean = false;
  get stateName(): string {
    if (this.isInsert)
      return '新增模式'
    else
      return '編輯模式';
  }
  get rowsCount(): number {
    if (this.list)
      //return this.list.instance.totalCount();
      return 1 // FIXME:
    else
      return 0;
  }

  constructor(){
    this.popEdit = new JkPopup();
    this.popFilter = new JkPopup();
  }
  init(
  list: MatSelectionList, entity: JkEntityV2){
    if(! list){
      alert('listSet.init list is undefined'+'error');
    }
    this.list = list;
    this.entity = entity;
    this.eventInit();
  }
  eventInit() {
    try {

      if (this.list) {
        // TODO:
        /*
        this.list.wordWrapEnabled = true;
        this.list.focusedRowIndex = 0;
        this.list.showBorders = true;
        this.list.focusedRowEnabled = true;
        this.list.allowColumnResizing = true;
        this.list.showRowLines = true;
        this.list.autoNavigateToFocusedRow = true;
        this.list.onRowDblClick.subscribe((e) => { this.onRowDblClick(e); });
        this.list.onKeyDown.subscribe((e) => { this.onKeyDown(e); });
        this.list.onFocusedRowChanging.subscribe((e) => { this.onFocusedRowChanging(e); });
        this.list.onFocusedRowChanged.subscribe((e) => { this.onFocusedRowChanged(e); });
        this.list.onExporting.subscribe((e) => { this.onExporting(e); });
        this.list.filterRow.visible = true;
        this.list.export.enabled = true;
        this.list.export.allowExportSelectedData = true;
        this.list.columnChooser.enabled = true;
        this.list.columnChooser.mode = "select";

        this.list.scrolling.rowRenderingMode = "virtual";
        this.list.scrolling.mode = "standard";
        this.list.filterValue = this.listFilterValue;

        //this.list.paging.enabled = true;
        //this.list.paging.pageIndex = 0;
        //this.list.paging.pageSize = 10;
        this.list.pager.visible = 'auto';
        this.list.pager.allowedPageSizes = this.allowedPageSizes; // 'auto';
        this.list.pager.showPageSizeSelector = this.showPageSizeSelector;
        this.list.pager.showInfo = this.showInfo;
        this.list.pager.showNavigationButtons = this.showNavButtons;

        this.list.editing.mode = "popup";
        this.list.editing.allowAdding = false;
        this.list.editing.allowUpdating = false;
        this.list.editing.allowDeleting = false;

        //let btn1 = {location:"before",widget:"dxButton",options:this.myFilterOption};
        // this.list.toolbar.items.push("addRowButton","applyFilterButton", "columnChooserButton", "exportButton", "groupPanel", "revertButton", "saveButton", "searchPanel");
        if(this.list.toolbar){
          //this.list.toolbar.items.push("exportButton");
        };
        //this.list.toolbar.items.push(btn1);
        //'applyFilterButton' | 'columnChooserButton' | 'exportButton' | 'groupPanel' | 'revertButton' | 'saveButton' | 'searchPanel'
        */
      }

      if (this.entity) {
        /*
        this.list.onInitNewRow.subscribe((e) => { this.entity.gridInitNewRow(e); });
        this.list.onRowInserted.subscribe((e) => { this.entity.jkRowInserted(e); });
        this.list.onRowInserting.subscribe((e) => { this.entity.jkRowInserting(e); });
        this.list.onRowUpdated.subscribe((e) => { this.entity.jkRowUpdated(e); });
        this.list.onRowUpdating.subscribe((e) => { this.entity.jkRowUpdating(e); });
        this.list.onEditingStart.subscribe((e) => { this.entity.jkEditingStart(e); });
        */
      }
    } catch (error: any) {
      alert(error.message);
    }
  }
  doRefreshOption = {
    accessKey: 'R', hint: 'Alt-R:重查資料', visible: true,
    icon: 'refresh',
    //text: '重查',
    onClick: async () => {
      await this.refreshData();
      /*this.entity.loadData()
        .then(() => {
          this.grid.instance.refresh();
        });*/
    }
  };
  async refreshData() {
    // this.list.instance.refresh();
  }

}
